import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {ButtonInfo} from 'components/buttons';
import {REPORT_TYPES} from 'helpers/constants/reports';
import {DISCOUNT_MODALS_V2} from 'helpers/constants/discountsV2';
import {PUSH_MODALS_STACK} from 'store/discountsV2/action';
import IconCoupon from 'assets/mainPage/growthPrograms/icon-discounts-coupon.svg';
import IconOrdersRedeemed from 'assets/mainPage/growthPrograms/icon-orders-redeemed.svg';
import {
  GrowthWidgetCard,
  GrowthWidgetColumn,
  GrowthWidgetFooter,
  GrowthWidgetHeader,
  GrowthWidgetHint,
  GrowthWidgetInfo,
  GrowthWidgetMetric,
  GrowthWidgetSplit
} from 'routes/App/MainPage/Components/GrowthPrograms/styles';
import {
  formatCount,
  formatTrendPercent
} from 'routes/App/MainPage/Components/GrowthPrograms/utils';

const DiscountsWidget = ({
  activeCount,
  ordersRedeemed,
  ordersRedeemedTrend
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const hasActiveDiscounts = Number(activeCount) > 0;
  const redeemedTrend = formatTrendPercent(ordersRedeemedTrend);

  const goToManageDiscounts = () => {
    history.push('/discounts-v2/your-discounts');
  };

  const goToCreateDiscount = () => {
    dispatch(PUSH_MODALS_STACK({type: DISCOUNT_MODALS_V2.SELECT}));
    history.push('/discounts-v2/your-discounts');
  };

  const requestUsageReport = () => {
    history.push(`/reports?type=${REPORT_TYPES.DISCOUNT_SUMMARY}`);
  };

  if (!hasActiveDiscounts) {
    return (
      <GrowthWidgetCard>
        <GrowthWidgetHeader className='withInfoPadding'>
          <img className='widgetIcon' src={IconCoupon} alt='' />
          <span className='title'>Discounts</span>
        </GrowthWidgetHeader>
        <GrowthWidgetInfo>
          <ButtonInfo className='OutlineBig ButtonInfoDrop'>
            <div className='DropInfo DropInfoMainPage LeftSide'>
              Attract new customers and boost order volume with targeted offers.
            </div>
          </ButtonInfo>
        </GrowthWidgetInfo>
        <GrowthWidgetMetric>0</GrowthWidgetMetric>
        <GrowthWidgetHint>
          Attract new customers and boost order volume with targeted offers
        </GrowthWidgetHint>
        <GrowthWidgetFooter>
          <span onClick={goToCreateDiscount}>Add your first discount</span>
        </GrowthWidgetFooter>
      </GrowthWidgetCard>
    );
  }

  return (
    <GrowthWidgetCard>
      <GrowthWidgetSplit>
        <GrowthWidgetColumn>
          <GrowthWidgetHeader>
            <img className='widgetIcon' src={IconCoupon} alt='' />
            <span className='title'>Active Discounts</span>
          </GrowthWidgetHeader>
          <GrowthWidgetMetric>{formatCount(activeCount)}</GrowthWidgetMetric>
          <GrowthWidgetFooter>
            <span onClick={goToManageDiscounts}>Manage discounts</span>
          </GrowthWidgetFooter>
        </GrowthWidgetColumn>
        <GrowthWidgetColumn>
          <GrowthWidgetHeader>
            <img className='widgetIcon' src={IconOrdersRedeemed} alt='' />
            <span className='title'>Orders Redeemed Discounts</span>
          </GrowthWidgetHeader>
          <GrowthWidgetMetric>
            {formatCount(ordersRedeemed)}
            {redeemedTrend && (
              <span className={`trend${redeemedTrend.className}`}>
                {redeemedTrend.label}
              </span>
            )}
          </GrowthWidgetMetric>
          <GrowthWidgetFooter>
            <span onClick={requestUsageReport}>Request usage report</span>
          </GrowthWidgetFooter>
        </GrowthWidgetColumn>
      </GrowthWidgetSplit>
    </GrowthWidgetCard>
  );
};

DiscountsWidget.propTypes = {
  activeCount: PropTypes.number,
  ordersRedeemed: PropTypes.number,
  ordersRedeemedTrend: PropTypes.number
};

DiscountsWidget.defaultProps = {
  activeCount: 0,
  ordersRedeemed: 0,
  ordersRedeemedTrend: null
};

export default DiscountsWidget;
